import { LDFlagSet } from 'launchdarkly-react-client-sdk';

import { ConsolidatedForecastListItem } from '@futrli-sdk/consolidations';
import { CurrentUserCheck } from '@futrli/shared-services/authenticator/auth0/types';
import { WorkspaceMember } from '@futrli-sdk/people';

import { ExtendedForecastListItem, ForecastActions } from './forecastsList';
import { getUserName } from '../../utils/users/getUserName';

export type ExtendedConsolidatedForecastListItem = ExtendedForecastListItem & ConsolidatedForecastListItem;

export const processConsolidatedForecast = (
  forecast: ConsolidatedForecastListItem,
  currentUser: CurrentUserCheck,
  members: WorkspaceMember[],
  flags: LDFlagSet = {}
): ExtendedConsolidatedForecastListItem => {
  const isOwner = forecast.owner_id === currentUser.id;
  const hasResourceSharingEnabled = !!flags.resourceSharing;
  const owner = members.find(member => member.id === forecast.owner_id);
  const ownerName = owner ? getUserName(owner.name) : undefined;
  const legacyPublicationActions: Pick<ForecastActions, 'publish' | 'unpublish'> = hasResourceSharingEnabled
    ? { publish: false, unpublish: false }
    : {
        publish: isOwner && forecast.status === 'draft',
        unpublish: isOwner && forecast.status === 'published'
      };

  return {
    ...forecast,
    isOwner,
    ownerName,
    actions: {
      delete: true,
      duplicate: true,
      edit: true,
      exportToExcel: false,
      exportToGoogleSheets: true,
      lock: false,
      ...legacyPublicationActions,
      share: hasResourceSharingEnabled
    },
    is_frozen: false,
    include_unpaid_invoices: false,
    is_hidden: false,
    include_ai_assumptions: false,
    checklist: []
  };
};

export const processConsolidatedForecasts = (
  forecasts: ConsolidatedForecastListItem[],
  currentUser: CurrentUserCheck,
  members: WorkspaceMember[],
  flags: LDFlagSet = {}
): ExtendedConsolidatedForecastListItem[] =>
  forecasts.map(forecast => processConsolidatedForecast(forecast, currentUser, members, flags));
